import React from "react";
import { useRouter } from "next/router";
import useDialog from "./useDialog";

/**
 * 헤더 "해봄 체험하기" → 참여자 유형 선택. 기존 Header 의 연령 선택 모달과 같은 갈래입니다.
 *
 * 여기서 이동하는 `/play`(14세 미만)·`/play1`(14세 이상)은 로그인 없이 들어오는 것이
 * 정책입니다. 두 페이지에는 인증 가드를 붙이면 안 됩니다.
 */
export default function LandingPlayModal({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const router = useRouter();
  const { ref, onBackdropClick } = useDialog(open, onClose);

  const go = (path: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    router.push(path);
  };

  return (
    <dialog
      className="modal modal-sm"
      ref={ref}
      onClick={onBackdropClick}
      aria-labelledby="play-title"
    >
      <div className="modal-card">
        <button type="button" className="modal-close" onClick={onClose} aria-label="닫기">
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path
              d="m5 5 10 10M15 5 5 15"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
          </svg>
        </button>

        <h2 className="modal-title" id="play-title">
          해봄 체험하기
        </h2>
        <p className="modal-sub">참여자 유형을 선택해 주세요.</p>

        <div className="play-options">
          <a className="play-option" href="/play" onClick={go("/play")}>
            <span className="play-option-title">14세 미만(학생)</span>
            <span className="play-option-desc">학교·학년·닉네임으로 참여해요.</span>
          </a>
          <a className="play-option" href="/play1" onClick={go("/play1")}>
            <span className="play-option-title">14세 이상(일반)</span>
            <span className="play-option-desc">이름·소속·연락처로 참여해요.</span>
          </a>
        </div>
      </div>
    </dialog>
  );
}
